﻿window.cWizardItem = function() {
}